import { useEffect, useRef, useState } from 'react';
import { ModifiersListView } from 'root/consts';
import { useGetHtmlTag } from 'root/hooks/useGetHtmlTag';
import { useStyles } from '@wix/tpa-settings/react';
import { modifiersStylesParams } from 'root/components/Menus/Settings/Tabs/DesignTab/DesignStylesParams';
import type { ModifierGroup } from 'root/apiTypes';
import { useTranslation } from '@wix/yoshi-flow-editor';

export const useModifierGroupsLogic = (modifierGroups: ModifierGroup[]) => {
  const modifierGroupTitleHtmlTag = useGetHtmlTag('modifierGroupTheme');
  const { t } = useTranslation();
  const styles = useStyles();
  const modifierListView = styles.get(modifiersStylesParams.modifiersListView);
  const isModifierListCollapsed = modifierListView === ModifiersListView.Collapse;
  const [isCollapsed, setIsCollapsed] = useState(isModifierListCollapsed);
  const firstShowMoreElementRef = useRef<HTMLDivElement>(null);
  const shouldRefFocus = (modifierGroupIndex: number, modifierIndex?: number) => {
    if (modifierGroups[0].modifiers.length > 3) {
      if (modifierGroupIndex === 0 && modifierIndex === 3) {
        return true;
      }
    } else if (modifierGroupIndex === 1 && modifierIndex === undefined) {
      return true;
    }
    return false;
  };
  useEffect(() => {
    setIsCollapsed(isModifierListCollapsed);
  }, [isModifierListCollapsed]);

  const onChangeShowButton = () => {
    const newCollapsedState = !isCollapsed;
    setIsCollapsed(newCollapsedState);
    if (!newCollapsedState) {
      requestAnimationFrame(() => {
        firstShowMoreElementRef?.current?.focus();
      });
    }
  };
  const showButtonText = t(
    isCollapsed
      ? 'app.widget.modifier-groups.show-button.more-text'
      : 'app.widget.modifier-groups.show-button.less-text'
  );
  const shouldShowModifierGroup = (modifierGroupIndex: number) => !isCollapsed || modifierGroupIndex === 0;
  const shouldShowModifier = (modifierIndex: number) => !isCollapsed || modifierIndex < 3;
  const shouldShowShowButton =
    (modifierGroups.length > 1 || modifierGroups[0].modifiers?.length > 3) && isModifierListCollapsed;
  return {
    modifierGroupTitleHtmlTag,
    showButtonText,
    onChangeShowButton,
    isCollapsed,
    modifierListView,
    shouldShowModifierGroup,
    shouldShowModifier,
    shouldShowShowButton,
    shouldRefFocus,
    firstShowMoreElementRef,
  };
};
